module.exports = __webpack_public_path__ + "static/media/craft_success_second.3845a9ad.mp3";